<template>
    <div>
        <div class="page-top mb-1 mb-3 align-center clearfix">
            <h1 class="float-left"> Fee External Voucher </h1>
            <div class="searching float-right mr-2">
                <input id="customSearch" type="text" class="form-control search" name="" />
            </div>
        </div>
        <table id="feeExternalVoucher" class="table">
            <thead>
            <tr>
                <th style="display: none;"></th>
                <th>Reference No.</th>
                <th>Reference Name</th>
                <th>Challan Number</th>
                <th>Due Date</th>
                <th>Amount</th>
                <th>Amount After Due Date</th>
                <th>Bifurcation</th>
                <th>Status</th>
                <th>Action</th>
            </tr>
            </thead>
        </table>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null
            };
        },
        mounted() {
            this.$Progress.start();
            var feeExternalVoucher = $('#feeExternalVoucher').DataTable({
                "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                processing: true,
                serverSide: true,
                ajax: {
                    "url": "api/listFeeExternalVoucher",
                    "headers": window.axios.defaults.headers.common,
                    "dataSrc": "records",
                },
                deferRender: true,
                columns: [
                    {data: 'id', visible: false},
                    {data: 'reference_number'},
                    {data: 'reference_name'},
                    {data: 'challan_number'},
                    {data: 'due_date'},
                    {data: 'amount_within_duedate'},
                    {data: 'amount_after_duedate'},
                    {data: 'bifurcation'},
                    {data: 'status'},
                    {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/feeExternalVoucherDetail/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit"><i class="fas fa-pencil-alt"></i></a>';
                        }}
                ],
                "order": [[ 0, "desc" ]],
                "columnDefs": [{
                    className: "text-center",
                    "targets": [ 4 ]
                }],
                "initComplete": () => {
                    this.$Progress.finish();
                }
            });
            $('#customSearch').on( 'keyup', function () {
                feeExternalVoucher.search(this.value).draw();
            });
        },
        created() {
            //
        }
    }
</script>
